import { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from '@mui/material';
import {
    Edit,
    ArrowDropUp,
    TaskAlt,
    RadioButtonUnchecked,
    NotInterested,
    Delete,
} from '@mui/icons-material';
import { apiAbsenceList } from '../../services/absenceList/AbsenceList';
import { apiAbsenceHolidayRangeList } from '../../services/absenceHolidayRangeList/AbsenceHolidayRangeList';
import '../feature-card.css';
import { useSwipeable } from 'react-swipeable';
import { Link } from 'react-router-dom';
import { apiAbsenceDelete } from '../../services/absenceDelete/AbsenceDelete';
import Utils from '../../utils/utils';
import HolidayRangeItem from './HolidayRangeItem';
import './absenceListComponent.css';

const formatHoursForDisplay = (value) => {
    if (value === null || value === undefined || value === '') return '';

    const textValue = String(value);
    const timeMatch = textValue.match(/^(\d{1,2}):(\d{2})$/);
    const totalMinutes = timeMatch
        ? Number(timeMatch[1]) * 60 + Number(timeMatch[2])
        : Math.round(Number(textValue.replace(',', '.')) * 60);

    if (Number.isNaN(totalMinutes)) return textValue;

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (minutes === 0) return `${hours} ${hours === 1 ? 'godzina' : 'godzin'}`;
    if (hours === 0) return `${minutes} min`;

    return `${hours} godz. ${minutes} min`;
};

const AbsenceTypeIcon = ({ typeId }) => {
    const iconTypeAliases = {
        27: 12,
    };
    const iconTypeId = iconTypeAliases[typeId] ?? typeId;
    const iconPath = `/icons/absence/${iconTypeId}.svg`;

    const handleIconError = (event) => {
        event.currentTarget.style.display = 'none';
    };

    return (
        <img
            src={iconPath}
            alt=""
            aria-hidden="true"
            onError={handleIconError}
            className="absence-type-icon"
        />
    );
};

const AbsenceList = () => {
    const isAuthenticated =
        localStorage.getItem('token') !== null &&
        localStorage.getItem('token') !== '';
    const [absences, setAbsences] = useState([]); // State to store absence data
    const [absencesHolidayRange, setAbsenceHolidayRange] = useState(null); // State to store absence data
    const [isLoading, setIsLoading] = useState(true);
    const [isMore, setIsMore] = useState(false);
    const [backToTopButton, setBackToTopButton] = useState(false);

    const logOff = () => {
        localStorage.setItem('token', '');
        localStorage.setItem('fullName', '');
        localStorage.setItem('role', '');
        localStorage.setItem('email', '');
        localStorage.setItem('avatar', '');
        window.location.href = '/';
    };

    const refreshItems = async () => {
        setIsLoading(true);

        try {
            let data = null;
            data = await apiAbsenceList.post({
                start: 0,
                end: 10000,
                year: new Date().getFullYear(),
            });

            if (data && data.items) setAbsences(data.items);
            else {
                localStorage.setItem('token', '');
                localStorage.setItem('fullName', '');
                localStorage.setItem('role', '');
                localStorage.setItem('email', '');
                localStorage.setItem('avatar', '');
                window.location.href = '/login';
            }

            data = await apiAbsenceHolidayRangeList.post({
                start: 0,
                end: 10000,
                year: new Date().getFullYear(),
            });

            if (data && data.items) {
                if (data.items.length > 0)
                    setAbsenceHolidayRange(data.items[0]);

                setIsLoading(false);
            } else {
                localStorage.setItem('token', '');
                localStorage.setItem('fullName', '');
                localStorage.setItem('role', '');
                localStorage.setItem('email', '');
                localStorage.setItem('avatar', '');
                window.location.href = '/login';
            }
        } catch (error) {
            console.error('Error fetching absences:', error);
        }
    };

    useEffect(() => {
        if (!isAuthenticated) window.location.href = '/login';

        async function fetchData() {
            await refreshItems();
        }
        fetchData();
        //setAbsences([{dateFrom:'2023-05-01', dateTo: '2023-05-30', type: 'Urlop wypoczynkowy', reason: 'Brak'},{dateFrom:'2023-05-01', dateTo: '2023-05-30', type: 'Urlop wypoczynkowy', reason: 'Brak'}])
    }, []); // Run only on component mount

    useEffect(() => {
        const handleScroll = () => {
            setBackToTopButton(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollUp = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="home-hero">
            {isLoading && (
                <Grid container item xs={12}>
                    <Grid item xs={12}>
                        <br />
                    </Grid>
                    <Grid item xs={12} className="other">
                        <span className="loader-black"></span>
                    </Grid>
                </Grid>
            )}
            {!isLoading && (
                <div className="not-mobile">
                    <Grid container className="padding-body">
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={2}>
                                    <h3>Lista nieobecności:</h3>
                                </Grid>
                                <Grid item xs={8}></Grid>
                                <Grid item xs={2}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        size="large"
                                        className="buttonFilled absenceList-button"
                                        href="/absence"
                                    >
                                        Dodaj nieobecność
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <br />
                        </Grid>
                        {absencesHolidayRange != null && (
                            <Grid item xs={12}>
                                <Grid container>
                                    <HolidayRangeItem
                                        label="Urlop wypoczynkowy" 
                                        leftDays={absencesHolidayRange.holidayTime}
                                        fullDays={absencesHolidayRange.holidayTimeFull}
                                        absenceTypeId={2}
                                    />
                                    <HolidayRangeItem absenceTypeId={10}
                                        label="Urlop wypoczynkowy na żądanie"
                                        leftDays={absencesHolidayRange.holidayRequestTime}
                                        fullDays={absencesHolidayRange.holidayRequestTimeFull}
                                    />
                                    {isMore && absencesHolidayRange.babyTimeFull > 0 && (
                                        <HolidayRangeItem
                                            label="Dzień na dziecko"
                                            leftDays={absencesHolidayRange.babyTime}
                                            fullDays={absencesHolidayRange.babyTimeFull}
                                        />
                                    )}
                                    {isMore && absencesHolidayRange.higherPowerHolidayTimeFull > 0 && (
                                        <HolidayRangeItem
                                            label="Urlop siła wyższa"
                                            leftDays={absencesHolidayRange.higherPowerHolidayTime}
                                            fullDays={absencesHolidayRange.higherPowerHolidayTimeFull}
                                        />
                                    )}
                                    {isMore && absencesHolidayRange.caringFamilyMemberTimeFull !== absencesHolidayRange.caringFamilyMemberTime && (
                                        <HolidayRangeItem
                                            label="Opieka nad członkiem rodziny"
                                            leftDays={absencesHolidayRange.caringFamilyMemberTime}
                                            fullDays={absencesHolidayRange.caringFamilyMemberTimeFull}
                                        />
                                    )}
                                    <Grid item xs={12}>
                                        <div
                                            className="holiday-toggle pointer"
                                            onClick={() => setIsMore(!isMore)}
                                        >
                                            <i>
                                                {isMore
                                                    ? 'mniej ...'
                                                    : 'więcej ...'}
                                            </i>
                                        </div>
                                        <br />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <TableContainer className="document-list">
                                <Table
                                    aria-labelledby="tableTitle"
                                    aria-label="enhanced table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">
                                                LP
                                            </TableCell>
                                            <TableCell align="left">
                                                Data od
                                            </TableCell>
                                            <TableCell align="left">
                                                Data do
                                            </TableCell>
                                            <TableCell align="left">
                                                Rodzaj nieobecności
                                            </TableCell>
                                            <TableCell align="left">
                                                Opis
                                            </TableCell>
                                            <TableCell align="center">
                                                Dni
                                            </TableCell>
                                            <TableCell align="center">
                                                Godziny
                                            </TableCell>
                                            <TableCell align="center">Status</TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {absences.map((row, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell align="left">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.dateFrom}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.dateTo}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <span
                                                            className={`absence-type-cell ${
                                                                row.isRejected ? 'absence-type-cell-rejected' : ''
                                                            }`}
                                                        >
                                                            <AbsenceTypeIcon typeId={row.typeId} />
                                                            {row.isRejected && <span className="absenceRejectLink">{row.type}</span>}
                                                            {!row.isRejected && <span>{row.type}</span>}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.description}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.days}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {formatHoursForDisplay(row.hours)}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.isAccepted && (
                                                            <Tooltip title="Nieobecność zaakceptowana">
                                                                <TaskAlt className="green-dot-web" />
                                                            </Tooltip>
                                                        )}
                                                        {!row.isAccepted && !row.isRejected && (
                                                            <Tooltip title="Nieobecność oczekuje na akceptację">
                                                                <RadioButtonUnchecked className="green-dot-web" />
                                                            </Tooltip>
                                                        )}
                                                        {row.isRejected && (
                                                            <Tooltip title="Nieobecność odrzucona">
                                                                <NotInterested className="green-dot-web" />
                                                            </Tooltip>
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {!row.isAccepted &&
                                                            !row.isRejected && (
                                                                <Link
                                                                    to={`/absence?id=${row.id}`}
                                                                >
                                                                    <Edit />{' '}
                                                                    {/* Render the EditIcon component */}
                                                                </Link>
                                                            )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            )}
            {!isLoading && (
                <div className="only-mobile">
                    <div className="absence-list">
                        <Grid container className="padding-body-small">
                            {absencesHolidayRange != null && (
                                <>
                                    <HolidayRangeItem
                                        label="Urlop wypoczynkowy" absenceTypeId={2}
                                        leftDays={
                                            absencesHolidayRange.holidayTime
                                        }
                                        fullDays={
                                            absencesHolidayRange.holidayTimeFull
                                        }
                                        mobile
                                        onClick={() => setIsMore(!isMore)}
                                    />

                                    {isMore && (
                                        <HolidayRangeItem absenceTypeId={10}
                                            label="Urlop na żądanie"
                                            leftDays={
                                                absencesHolidayRange.holidayRequestTime
                                            }
                                            fullDays={
                                                absencesHolidayRange.holidayRequestTimeFull
                                            }
                                            mobile
                                            onClick={() => setIsMore(!isMore)}
                                        />
                                    )}

                                    {isMore &&
                                        absencesHolidayRange.babyTimeFull >
                                            0 && (
                                            <HolidayRangeItem
                                                label="Dzień na dziecko"
                                                leftDays={
                                                    absencesHolidayRange.babyTime
                                                }
                                                fullDays={
                                                    absencesHolidayRange.babyTimeFull
                                                }
                                                mobile
                                                onClick={() =>
                                                    setIsMore(!isMore)
                                                }
                                            />
                                        )}

                                    {isMore &&
                                        absencesHolidayRange.higherPowerHolidayTimeFull >
                                            0 && (
                                            <HolidayRangeItem
                                                label="Urlop siła wyższa"
                                                leftDays={
                                                    absencesHolidayRange.higherPowerHolidayTime
                                                }
                                                fullDays={
                                                    absencesHolidayRange.higherPowerHolidayTimeFull
                                                }
                                                mobile
                                                onClick={() =>
                                                    setIsMore(!isMore)
                                                }
                                            />
                                        )}

                                    {isMore &&
                                             absencesHolidayRange.caringFamilyMemberTimeFull !== absencesHolidayRange.caringFamilyMemberTime
                                             && (
                                            <HolidayRangeItem
                                                label="Opieka nad członkiem rodziny"
                                                leftDays={
                                                    absencesHolidayRange.caringFamilyMemberTime
                                                }
                                                fullDays={
                                                    absencesHolidayRange.caringFamilyMemberTimeFull
                                                }
                                                mobile
                                                onClick={() =>
                                                    setIsMore(!isMore)
                                                }
                                            />
                                        )}

                                    <Grid item xs={12}>
                                        <div
                                            className="holiday-toggle pointer"
                                            onClick={() => setIsMore(!isMore)}
                                        >
                                            <i>
                                                {isMore
                                                    ? 'mniej ...'
                                                    : 'więcej ...'}
                                            </i>
                                        </div>
                                        <br />
                                    </Grid>
                                </>
                            )}

                            <Grid item xs={12}>
                                <p>
                                    <b>Lista nieobecności:</b>
                                </p>
                                <br />
                            </Grid>

                            <Grid item xs={12}>
                                <div className="home-container3">
                                    {absences.map((absence) => (
                                        <AbsenceListItem
                                            key={absence.id}
                                            absence={absence}
                                            setIsLoading={setIsLoading}
                                        />
                                    ))}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    {backToTopButton && (
                        <Button
                            className="only-mobile scroll-top-button"
                            onClick={scrollUp}
                        >
                            <ArrowDropUp />
                        </Button>
                    )}
                    <div className="width100">
                        <div className="home-btn-group only-mobile">
                            <Button
                                className="buttonFilled"
                                onClick={() => logOff()}
                            >
                                Wyloguj
                            </Button>
                        </div>
                        <div className="clr"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

const AbsenceListItem = ({ absence, setIsLoading }) => {
    const [showDelete, setShowDelete] = useState(false);

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => setShowDelete(true),
        onSwipedRight: () => setShowDelete(false),
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    const clickAbsence = (item) => {
        if (!item.isRejected)
            window.location.href = '/absence?id=' + absence.id;
    };

    const handleDelete = async (id) => {
        setIsLoading(true);
        const absenceDelete = await apiAbsenceDelete.post({ id: id });
        if (absenceDelete) {
            setIsLoading(false);
            window.location.href = '/absenceList';
        }
    };

const itemContent = (
    <>
        {!absence.isAccepted && (
            <div className="delete-button-area">
                <button
                    className="delete-btn"
                    onClick={() => handleDelete(absence.id)}
                >
                    <Delete />
                </button>
            </div>
        )}

        <div className={`absence-item-content ${showDelete ? 'slid' : ''}`}>
            <Box
                className={`absence-card-box ${
                    absence.isRejected
                        ? 'absence-card-box-rejected'
                        : absence.isAccepted
                          ? 'absence-card-box-approved'
                          : 'absence-card-box-pending'
                }`}
                onClick={() => clickAbsence(absence)}
            >
                <Box className="absence-card-left">
                    <AbsenceTypeIcon typeId={absence.typeId} />
                </Box>

                <Box className="absence-card-center">
                    <h3 className="feature-card-text heading3">
                        {absence.isAccepted && (
                            <Link
                                className="absenceApprovedLink"
                                to={`/absence?id=${absence.id}`}
                            >
                                {absence.type}
                            </Link>
                        )}

                        {absence.isRejected && (
                            <Link className="absenceRejectLink">
                                {absence.type}
                            </Link>
                        )}

                        {!absence.isAccepted && !absence.isRejected && (
                            <Link
                                className="absenceLink"
                                to={`/absence?id=${absence.id}`}
                            >
                                {absence.type}
                            </Link>
                        )}
                    </h3>

                    <span className="bodySmall">
                        <b>
                            {Utils.formatDate(absence.dateFrom)} -{' '}
                            {Utils.formatDate(absence.dateTo)}
                        </b>
                    </span>

                    <span className="bodySmall">
                        <b>
                            {absence.days} {absence.days === 1 ? "dzień" : "dni"} - {formatHoursForDisplay(absence.hours)}
                        </b>
                    </span>
                </Box>

                {absence.isIcon && (
                    <Box className="absence-card-right">
                        {absence.isAccepted && <TaskAlt className="status-icon" />}

                        {!absence.isAccepted && !absence.isRejected && (
                            <RadioButtonUnchecked className="status-icon" />
                        )}

                        {absence.isRejected && (
                            <span className="status-icon reject-status-icon">
                                <svg
                                    viewBox="0 0 72 72"
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <circle
                                        cx="36"
                                        cy="36"
                                        r="27"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="5"
                                    />
                                    <path
                                        d="M27 27 L45 45 M45 27 L27 45"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </span>
                        )}
                    </Box>
                )}
            </Box>
        </div>
    </>
);

    return !absence.isAccepted ? (
        <div className="absence-item-wrapper" {...swipeHandlers}>
            {itemContent}
        </div>
    ) : (
        <div className="absence-item-wrapper">{itemContent}</div>
    );
};

export default AbsenceList;
